import React from 'react'

const LibraryTour = ({ setStepsEnabled, setHomeScreenWalkThroughPopup }) => {
  return (
    <div className="ContainerSubmitedSucess2 ">
      <div className="SubContainerSubmitedSucess innerContainerFlex">
        <div className="imageContainer">
          <img src="/gif/library_guide.gif" alt="" />
        </div>
        <div className="rightContainer">
          <div className="studentLogos leftMargin">
            <div></div>
            <div>
              <img
                src="/StudentImg/BreathSchoolLogo.png"
                alt="icon"
                width={"30px"}
              ></img>
            </div>
          </div>
          <div className=" overallMarginHead" style={{ position: "relative" }}>
            <h4 className="textColor1"> Welcome to Library Section</h4>
            <img style={{ width: "35px", height: "35px", position: "absolute", left: "87%", top: "195px", cursor: "pointer", zIndex: "999" }} src="./images/down_arrow.png" alt="arrowimag" onClick={() => {
              document.getElementById("last-paragraph").scrollIntoView({ behavior: "smooth" })
            }} />
          </div>

          <div className=" overallMargin">
            <p className="textColor2" >
              1. Access Content Anytime, Anywhere.
            </p>
            <hr></hr>
            <p className="textColor2" >
              2. Interactive and Engaging Content.
            </p>
            <hr></hr>
            <p className="textColor2" >
              3. Enhanced Learning through Multimedia Formats: Text, Audio, Video.
            </p>
            <hr></hr>
            <p className="textColor2" >
              4. Comprehensive Coverage of Subjects.
            </p>
            <hr></hr>
            <p className="textColor2" >
              5. Self-Paced Learning through Notes and Bookmarks: Track and Review Progress.
            </p>
            <hr></hr>
            <p className="textColor2" >
              6. Personalized Learning: Manage Notes and Bookmarks for each Content Items.
            </p>
            <hr></hr>
            <p className="textColor2" id='last-paragraph'>
              7. Collaborative Learning with Peers and Teachers: Instant Resolution of Queries.
            </p>
            <hr></hr>
          </div>


          <div className="buttonsContainer">
            <button
              className="rightBtn"
              onClick={() => {
                setHomeScreenWalkThroughPopup(false);
                setStepsEnabled(true);
              }}
            >
              Take me to the product tour
            </button>
            <button
              className="leftBtn"
              onClick={() => setHomeScreenWalkThroughPopup(false)}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LibraryTour
